function heartland() {
  return GlobalPayments;
}